import React from "react"
import styled from "@emotion/styled"
import ReaderCard from "./reader-card"
import { graphql, useStaticQuery } from "gatsby"
import PropTypes from "prop-types"
import facepaint from "facepaint"
const breakpoints = [576, 768, 992, 1200]
const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`))

const Container = styled.div`
  text-align: center;
  max-width: 1000px;
  margin: 0 auto;
`
const Header = styled.h2`
  // 26px
  font-size: 2.625rem;
  padding: 0 18px;
  text-align: left;
  color: #e6b422;
  font-weight: bold;
`

const Year = styled.p`
  // 26px
  font-size: 2.625rem;
  padding: 0 18px;
  text-align: left;
  color: #e6b422;
  font-weight: bold;
  display: flex;
  align-items: center;

  width: 36%;
  &:after {
    content: "";
    flex-grow: 1;
    height: 1px;
    background: #c7a542;
    display: block;
    margin-left: 0.4em;
  }
`

const Comment = styled.p`
  // 10px
  font-size: 0.625rem;
  padding: 0 18px;
  text-align: left;
  color: #ffffff;
  display: flex;
  margin-top: 1rem;
`

const Cards = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding: 12px;
`

const Card = styled.div`
  display: flex;
  ${mq({
    width: ["50%", "33%", "25%", "25%"],
  })};
`

const NextReadersArchive = ({ year, noHeader }) => {
  const data = useStaticQuery(graphql`
    query NextReadersArchiveQuery {
      allLeaderCsv {
        edges {
          node {
            id
            name
            photo
            post_title
            post_url
            title
            year
          }
        }
      }
    }
  `)

  const leaders = data.allLeaderCsv.edges.filter(
    edge => year.toString() === edge.node.year
  )
  return (
    <Container id={`anchor_archive_${year}`}>
      {!noHeader && <Header>ARCHIVE</Header>}
      <Year>{year}</Year>
      {!noHeader && <Comment>※肩書きは掲載当時のまま記載しています</Comment>}
      <Cards>
        {leaders.map((leader, index) => {
          const key = `Cards-${leader.node.id}`
          return (
            <Card key={key}>
              <ReaderCard key={leader.node.id} {...leader.node}></ReaderCard>
            </Card>
          )
        })}
      </Cards>
    </Container>
  )
}

export default NextReadersArchive

NextReadersArchive.propTypes = {
  year: PropTypes.number.isRequired,
  noHeader: PropTypes.bool,
}
NextReadersArchive.defaultProps = {
  noHeader: false,
}
